import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import './assets/common.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {fullScreenContainer, loading, borderBox9, scrollBoard} from '@jiaminghi/data-view'

import * as loopShowTooltip from './utils/tooltip-auto-show-vue'

Vue.prototype.$autoLoop = loopShowTooltip

// 绑定AMap安全密钥
window._AMapSecurityConfig = {
    securityJsCode: '6c8bcaadd0dcfad1325c06a2fc36a4a5'
}

Vue.use(ElementUI)
Vue.use(fullScreenContainer)
Vue.use(loading)
Vue.use(borderBox9)
Vue.use(scrollBoard)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
